/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import { mapMutations } from 'vuex';
import helpers from './../../utils/helpers';
import productService from './../../services/product';
import store from './../../store';
import ProductImportExportErrorReport from './../../components/productImportExportErrorReportPopup/productImportExportErrorReportPopup.vue';

export default {

  data() {
    return {
      server: {
        url: helpers.buildUrl(`${process.env.API_LOCATION}/products/import`, {
          token: localStorage.getItem('id_token'),
        }),
        process: {
          onload: this.import,
          onerror: this.error,
        },
      },
    };
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
    }),

    downloadAllProducts() {
      window.open(helpers.buildUrl(`${process.env.API_LOCATION}/products/download`, {
        token: localStorage.getItem('id_token'),
      }));
    },

    import(response) {
      const result = JSON.parse(response);
      if (result.errors.length === 0 /*&& result.data.length === 0*/) {
        const params = {
          page: 1,
          limit: 50,
        };
        store.dispatch('setProductQuery', params);
        productService.items(params)
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$t('static.products.index.importProductsSuccessMessage'),
            type: 'success',
          });
          this.closeModal();
        });
      } else if (result.errors.length) {
        this.setModalProps({
          errors: result.errors,
        });
        this.toggle(true);
        this.setModalContent(() => ProductImportExportErrorReport);
      } else {
        const message = result.errors || this.$t('static.products.index.importProductsErrorMessage');
        if (result.errors) {
          this.$message({
            showClose: true,
            message,
            type: 'error',
          });
        }
      }
    },
    error(response) {
      const result = JSON.parse(response);
      const message = result.message || this.$t('static.products.index.importProductsErrorMessage');
      this.$message({
        showClose: true,
        message,
        type: 'error',
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/productImportExportPopup/productImportExportPopup.js